import FeatureGates from '@atlaskit/feature-gate-js-client';
import {
	cachedUserDocumentsQuery,
	type RecommendedObject,
	userDocumentsQuery,
} from '@atlassian/search-client';

export const fetchUserDocuments: (cloudId: string, userId: string, aggAbsoluteUrl: string | undefined) => Promise<{
    id: string;
    title: string;
    data: RecommendedObject;
    type: "user-document";
}[]> = async (
	cloudId: string,
	userId: string,
	aggAbsoluteUrl: string | undefined,
) => {
	const serveAutorefreshCohort =
		FeatureGates.getExperimentValue<string>(
			'quick_find_autorefresh_experiment_v3',
			'cohort',
			'control',
			{ fireExperimentExposure: false },
		) === 'autorefresh';

	const response = serveAutorefreshCohort
		? await cachedUserDocumentsQuery({
				variables: {
					userId,
					tenantId: cloudId,
					caller: 'quick-find',
					maxNumberOfResults: 6,
				},
				aggAbsoluteUrl,
				onlyRefreshIfExpired: true,
				returnExpired: false,
			})
		: await userDocumentsQuery({
				variables: {
					userId,
					tenantId: cloudId,
					caller: 'quick-find',
					maxNumberOfResults: 6,
				},
				aggAbsoluteUrl,
			});

	const recommendedObjects: RecommendedObject[] = response.data?.smarts?.recommendedObject || [];
	return recommendedObjects.filter((r) => Boolean(r.object)).map(mapEssentialData);
};

export const mapEssentialData: (result: RecommendedObject) => {
    id: string;
    title: string;
    data: RecommendedObject;
    type: "user-document";
} = (result: RecommendedObject) => {
	return {
		id: result.id,
		title: result?.object?.title || '',
		data: result,
		type: 'user-document' as const,
	};
};
